import angular from "angular";

angular
    .module('sockedIdRequest', [])
    .factory('sockedIdRequest', function () {
        return {
            request: function (config) {
                config.headers['X-Socket-ID'] = window.Echo.socketId();
                return config;
            }
        }
    });

export default 'sockedIdRequest';


// WEBPACK FOOTER //
// ./resources/assets/modules/app/socketIdRequest.js